var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length
    ? _c("recycle-scroller", {
        staticClass: "recycle-scroller-ks scroller",
        attrs: {
          items: _vm.items,
          "item-size": _vm.itemSize,
          buffer: _vm.buffer,
          keyField: _vm.prop.value,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ item, active, index }) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "home-ant-select-ppt__item",
                      style: { display: active ? "flex" : "none" },
                    },
                    [
                      _vm._t("default", null, {
                        item: item,
                        active: active,
                        prop: _vm.prop,
                        index: index,
                      }),
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }